
















































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { IUploadFile } from "./types";
import DialogUI from "./DialogUI.vue";
import { L } from "@/common/filters";

import { Exif } from "./Exif";
import { APIID, APP_URL, HEADER_AUTH, HEADER_BEARER } from "@/common/http";
import { User } from "@/components/User";
import axios from "axios";

const HEADER = [{
      text: '#',
      value: 'index',
      align: 'left'
  },{
      text: 'ชื่อไฟล์', 
      value: 'name'
  },{
      text: 'ขนาดไฟล์', 
      value: 'size',
      align: 'right'
  },{
      align: 'center',
      sortable: false
  }];

@Component({
  components:{
    'v-dialog': DialogUI
  },
  watch: {
    upload(value) {
      if (!!value) {
        this.startUpload();
      } else {
        this.stopUpload();
      }
    }
  }
})
export default class FileUploadUI extends Vue {
  @Prop({
    default: 0
  }) index:number;
  @Prop({
    default: true
  }) multiple: boolean;
  @Prop({
    default: []
  }) files: IUploadFile[];
  @Prop({
    default: '.*'
  }) accept: string;
  @Prop({
    default: false
  }) hideUploadButton: boolean;
  @Prop({
    default: ''
  }) url: string;
  @Prop({
    default: null
  }) user: User;
  @Prop({
    default: null
  }) category: number;
  @Prop({
    default: 'file_name'
  }) fileFieldName: string; // the column name where file name is stored
  @Prop({
    default: false
  }) upload:boolean;

  headers = HEADER;
  //files: IUploadFile[] = [];

  dragOver: boolean = false;
  dragOut: boolean = false;
  uploading:boolean = false;
  mounted() {
    //this.uploading = this.upload;
    window.addEventListener("dragover", this.onDragOver);
    window.addEventListener("drop", this.onWindowDrop);
  };

  beforeDestroy() {
    window.removeEventListener("dragover", this.onDragOver);
    window.removeEventListener("drop", this.onWindowDrop);
  };

  FileSize(file:IUploadFile) : string {
    let kb = 1024;
    let mb = kb * kb;
    let gb = kb * mb;
    let size;
    if (file.size>gb) {
      size = Math.round((file.size / gb) * 100) /  100 + 'GB';
     } else if (file.size>mb) {
      size = Math.round((file.size / mb) * 100) /  100 + 'MB';
     } else if (file.size>kb) {
      size = Math.round((file.size / kb) * 10) /  10 + 'KB';
     } else {
       size = file.size.toThousandCommaString() + 'B';
     }
     return size;
  };

  get isAcceptedFile() : boolean {
    if (!(this.files && this.files.length>0)) {
      return false;
    }
    let ext = this.accept.replace(/,/g,'$|').replace(/\./g,'\\.') + '$';
    let regex = new RegExp(ext,'i');
    return !!this.files[0].name.match(regex);
  };

  get ImageFile() {
    if (this.isAcceptedFile) {
      let file = this.files[0].file;
      return (window.URL) ? window.URL.createObjectURL(file) : window['webkitURL'].createObjectURL(file);
    }
    return null;
  }

  selectFiles() {
    (<HTMLElement>this.$refs.InputFile).click();
  };
  
  ImageURL = ''; // IMPORTANT: don't set to null otherwise v-img will alert error
  async createImageURL(file:File) {
    try {
      if (file.name.match(/\.pdf$/i)) {
        this.ImageURL = '/static/images/icon.pdf.png';
      } else {
        this.ImageURL = await Exif.createImageURL(file);
      }
    } catch (error) {
      console.log(error);
    }
  }

  ErrorMessage:string = null;
  onCloseError() {
    this.ErrorMessage = null;
  }

  async addFiles(files: File[]) {
    let uf:IUploadFile[] = [];
    let acceptible, ext;
    let errMsg = '';
    for (let i=0; i<files.length; i++) {
      acceptible = true;
      ext = '';
      if (!this.accept.match(/^\.*$/)) {
        acceptible = false;
        ext = files[i].name;
        ext = ext.substring(ext.lastIndexOf('.'));
        if (ext) {
          let regex = new RegExp(ext, 'i');
          acceptible = !!this.accept.match(regex);
        }
      }
      if (!acceptible) {
        if (ext && errMsg.indexOf(ext)==-1) {
          errMsg += (errMsg ? ', *' : '*') + ext;
        }
      } else {
        await this.getExif(files[i]);
        let coord = Exif.getCoordinates(files[i]);
        let lon=null, lat=null;
        if (coord) {
          lon = coord[0];
          lat = coord[1];
        }
        uf.push({
          index: this.files.length + i + 1,
          file: files[i],
          width: Exif.getTag(files[i], 'ImageWidth') || files[i]['width'] || null,
          height: Exif.getTag(files[i], 'ImageHeight') || files[i]['height'] || null,
          orientation: Exif.getTag(files[i], 'Orientation'),
          date: Exif.getDateTime(files[i]),
          longitude: lon,
          latitude: lat,
          hasCoordinate: !(lon===null || lat===null),
          uploading: false, // IMPORTANT, otherwise, UI wont refresh when changed to true
          name: files[i].name,
          size: files[i].size,
          progress: Math.floor(Math.random()*100) + 1
        });
      }
    }
    if (uf && uf.length>0) {
      this.$emit('addfiles', {index:this.index, files:uf});
    }
    if (errMsg) {
      this.ErrorMessage = L('notSupportedFile') + errMsg;
    }
  }

  getExif(file:File) : Promise<File> {
    let self = this;
    return new Promise((resolve,reject) => {
      if (file.name.match(/\.jpg$|\.jpeg$/i)) {
        Exif.getData(file, (exif) => {
          // file == exif. it has exifdata read by Exif
          self.createImageURL(file);
          resolve(file);
        }, self);
      } else {
        self.createImageURL(file);
        resolve(file);
      }
    });
  }

  doFileAction(file:IUploadFile) {
    if (file.uploading) {
      this.stopUpload(file);
    } else {
      this.$emit('removefile',{index:this.index,file:file});
    }
  };

  toggleUpload() {
    if (this.uploading) {
      this.stopUpload();
    } else {
      this.startUpload();
    }
  };

  async doUploadAFile(file) {
    try {
      let theFile:File = file.file;
      let formData = new FormData();
      let props:any = {
        category_fk: this.category,
        file_name: file.name,
        width: theFile['width'],
        height: theFile['height'],
        size_byte: file.size,
        exif_orientation: file.orientation,
        exif_date: file.date,
        user_fk: this.user.Code
      };
      if (file.hasCoordinate) {
        props.exif_lon = file.longitude;
        props.exif_lat = file.latitude;
      }
      //let data = await this.user.requestResource('mis/image_archive', 'POST', props);
      let data = await this.user.uploadFileUsingFetch(this.url, {
        fieldName: this.fileFieldName,
        filePath: file.name,
        file: theFile,
        details: props
      });
      file.uploaded = true;
      this.$emit('removefile',{index:this.index,file:file});
    } catch (error) {
      console.log(error);
    }
  }

  FETCHstartUpload() {
    let self = this;
    this.files.forEach((file) => {
      if (!file.uploaded) {
        self.doUploadAFile(file);
      }
    });
  }

  startUpload() {
    let self = this;
    self.uploading = true;
    this.files.forEach((file) => {
      if (!file.uploaded) {
        file.uploader = axios.create({
          baseURL: APP_URL + '/rest/',
          timeout: 4*60*1000, // 0: no timeout
          headers: {
            //"File-Name": file.name, // not allowed in by Access-Control-Allow-Headers in preflight response
            //"Content-Type": "application/octet-stream",
            "Accept": "application/json",
            "Authorization": 'Bearer ' + self.user.Token.access.token,
            "X-Requested-With": APIID
          }
        });
        let theFile:File = file.file;
        let formData = new FormData();
        let props:any = file.properties || {
          category_fk: this.category,
          file_name: file.name,
          width: theFile['width'],
          height: theFile['height'],
          size_byte: file.size,
          exif_orientation: file.orientation,
          exif_date: file.date,
          user_fk: this.user.Code
        };
        if (file.hasCoordinate && !!props.exif_date) {
          props.exif_lon = file.longitude;
          props.exif_lat = file.latitude;
        }
        formData.append(this.fileFieldName, theFile);
        formData.append('details', JSON.stringify(props));
        file.uploading = true;
        file.progress = 0;
        file.uploader.post(self.url, formData, {
          onUploadProgress: (event) => {
            file.progress = Math.round((event.loaded * 100 ) / event.total);
          },
          cancelToken: new axios.CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            file.cancel = c;
          })
        }).then(function(response) {
          file.uploaded = true;
          file.uploading = false;
          file.progress = 100;
          file.cancel = null;
          file.uploader = null;
          self.$emit('removefile',{index:self.index,file:file});
          self.uploading = (self.files.length>0);
          if (!self.uploading) {
            self.$emit('uploaded', {index:self.index});
          }
        })
        .catch(function (error) {
          self.uploading = false;
          file.uploaded = false;
          file.uploading = false;
          if (file.cancel) {
            file.cancel();
            file.cancel = null;
            file.uploader = null;
          }
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        });
      }
    });
  };

  stopUpload(file?:IUploadFile) {
    let self = this;
    let iFiles:IUploadFile[] = file ? [file] : this.files;
    iFiles.forEach((file) => {
      if (file.cancel) {
        file.cancel();
        file.uploaded = false;
        file.uploading = false;
      }
      self.uploading = false;
    });
  };

  onInputFileChange(event) {
    this.addFiles(event.target.files);
  };

  onDragEnter(e) {
    this.dragOver = true;
  };

  onDragLeave(e) {
    if (e.target.nodeName.match(/DIV|HTML/i) || 
        e.target === e.explicitOriginalTarget || 
       (e.screenX === 0 && e.screenY === 0 && !e.fromElement && e.offsetX <= 0)) {
      this.dragOver = false;
    }
  };

  onDragOver(e) {
    e.preventDefault();
    //this.dragOver = false;
  };

  onWindowDrop(e) {
    e.preventDefault();
    this.dragOver = false;
  };

  onDrop(e) {
    this.dragOver = false;
    this.addFiles(e.dataTransfer.files);
  };
}
